import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { AgreementBody } from "@/components/ProTermsModal";
import { ScrollText } from "lucide-react";

export default function ProTerms() {
  const [doc, setDoc] = useState(null);
  useEffect(() => { api.get("/legal/pro_terms").then(r => setDoc(r.data)).catch(() => {}); }, []);

  return (
    <div className="bg-[#F5F7F5] min-h-screen">
      <Header/>
      <div className="max-w-3xl mx-auto px-6 py-14" data-testid="pro-terms-page">
        <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#E1EDE7] text-[#245544] text-xs font-bold uppercase tracking-wider mb-4">
          <ScrollText size={13}/> For Professionals
        </span>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#2D2926] mb-3" style={{ fontFamily: "Outfit" }}>
          {doc?.title || "LIMYA Pro Terms"}
        </h1>
        <p className="text-[#5C554E] mb-10">
          These terms apply in addition to the LIMYA Terms of Use and Privacy Policy, and must be accepted
          when you create a Professional account.
        </p>
        <div className="bg-white border border-black/[0.07] rounded-2xl p-6 sm:p-8">
          {doc ? <AgreementBody doc={doc}/> : <p className="text-sm text-[#2D2926]/55">Loading…</p>}
        </div>
      </div>
      <Footer/>
    </div>
  );
}
